import PropTypes from 'prop-types';
import Handle from '../Handle';
import AddNodeButton from '../AddNodeButton';

function BlankNode(props) {
  const { id, keyPath, canAdd = false } = props;

  return (
    <div className="icp-workflow-node blank-node">
      <div data-id={id} className="icp-workflow-node-content is-blank">
        <Handle nodeId={id} type="target" />
        <Handle nodeId={id} type="source" />
      </div>
      {canAdd ? <AddNodeButton keyPath={keyPath} /> : null}
    </div>
  );
}

BlankNode.propTypes = {
  id: PropTypes.string,
  keyPath: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  canAdd: PropTypes.bool,
};

export default BlankNode;
